export const EQUIPMENT_DEFECTS_GRID_FILTER = {
  trailer: "trailer",
  tractor: "tractor",
  dolly: "dolly",
};

export const DEFAULT_EQUIPMENT_TYPE = EQUIPMENT_DEFECTS_GRID_FILTER.trailer;